var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 172 172"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#b5b7b9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M171 86A85 85 0 1 1 86 1a85 85 0 0 1 85 85M32.323 151.753c0-24.472 14.444-44.3 53.677-44.3s53.677 19.832 53.677 44.3m-22.909-86.765A30.768 30.768 0 1 1 86 34.219a30.77 30.77 0 0 1 30.768 30.769",
  "data-name": "Path 27329"
})));
export { SvgUser as ReactComponent };
export default __webpack_public_path__ + "static/media/user.84368e0cd8f7807adbe391a0982c1e7f.svg";